<template>
	<div>
		<nav>
			<v-app-bar app dark color="primary">
				<router-link to="/home"><v-img position="start start" :src="require('@/assets/img/logo_titulo_invert.svg')" class="my-3" contain height="40"></v-img></router-link>
				<v-spacer></v-spacer>
				<v-toolbar-items>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon ripple class="mx-2" v-on="on" @click="logout">
								<v-icon>logout</v-icon>
							</v-btn>
						</template>
						<span>Sair</span>
					</v-tooltip>

					<v-menu open-on-hover bottom offset-y class="hidden-sm-and-down">
						<template v-slot:activator="{ on }">
							<v-btn icon ripple class="mx-2" v-on="on"><v-icon>grade</v-icon></v-btn>
						</template>
						<v-list>
							<v-list-item>
								<v-btn text href="http://ensinarevoar.pt" target="_blank">Site</v-btn>
							</v-list-item>
							<v-list-item>
								<v-btn text href="http://comunidade.ensinarevoar.pt" target="_blank">Comunidade</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-toolbar-items>
			</v-app-bar>
		</nav>
	</div>
</template>

<script>
    export default {
        methods: {
			logout () {
				this.$http.post(process.env.VUE_APP_AUTH_ROOT + '/logout/').then(function(data){
					// console.log(data);

					this.$store.commit('setCurrentUser', null);

					this.$router.push({ name: 'login'})
				}, response => { // error callback
					console.log('ERRO', response);

					// TODO: mensagem com o erro
					alert('Ocorreu um erro');
				});
			}
        }
    }
</script>